
import { useEffect, useState } from "react";
import { useEmpleadoStore } from "../stores/useEmpleadoStore";
import { elToast } from "../functions/Alerta"
import url from "../api/url";


function useInputArchivo(tipo) {

    // variables
    const [cargando, setCargando] = useState(false)
    const [mostrarInput, setMostrarInput] = useState(true)
    const objLogueado = useEmpleadoStore(state => state.objLogueado)
    const [nombreArchivo, setNombreArchivo] = useState('')
    const [mostrarOcultar, setmostrarOcultar] = useState(false)
    const [completado, setCompletado] = useState(null)
    const { URL } = url()
    const maxSizeInBytes = 15 * 1024 * 1024; // 15 MB


    // funciones

    function procesarArchivo( e, tipo ) {
        if (e.target.value !== "") {

            var archivo = e.target.files[0]

            if (archivo.size > maxSizeInBytes) {
                alert( "El tamaño por archivo debe ser menor a 15 MB" )
                e.target.value = ""
                return
            }

            const extension = archivo.name.split('.').pop().toLowerCase();
            const extensionesPermitidas = ['jpg', 'jpeg', 'png', 'pdf'];


            if (extensionesPermitidas.includes(extension)) {

                let reader = new FileReader()
                reader.readAsDataURL(archivo)
                reader.onload = (f) => {
                    guardarArchivos(f.target.result, tipo, extension)
                }
            } else {
                alert( "Solo se admiten documentos en formato PDF o imágenes (jpg, jpeg, png)" )
                e.target.value = ""
            }
        } else {
            // Sin archivo
        }
    }

    const traerNombreArchivo = (tipo) => {

        if (!objLogueado.email) {
            return
        }
        var fd = new FormData()
        fd.append("funcion", "traerNombreArchivoOtro")
        fd.append("tipo", tipo)
        fd.append("correo", objLogueado.email)


        fetch( URL, {
            method: 'post',
            body: fd
        })
        .then( res => res.text() )
        .then( e => {

            if ( e !== 'vacio' ) {
                setNombreArchivo(e)
                setMostrarInput(false)
                setmostrarOcultar(true)
                setCompletado(true)
            } else {
                setCompletado(false)
            }
        })
        .catch( a => {
            elToast('Hay un error al traer tus archivos', 'error')
        })

    }


    const guardarArchivos = (archivo, tipo, extension) => {


        var body = new FormData();
        body.append( 'archivo', archivo )
        body.append( 'correo', objLogueado.email )
        body.append( 'tipo', tipo )
        body.append( 'extension', extension )
        body.append( 'funcion', 'guardarArchivo' )

        setCargando( true )
        fetch( URL, {
            method: 'post',
            body
        })
        .then( res => res.json() )
        .then( function (d) {
            if ( d.codigo === 1 ) {
                setNombreArchivo(d.url_archivo)
                elToast( d.mensaje )
                traerNombreArchivo(tipo)
                setMostrarInput( false )
                setmostrarOcultar( true )
                setCompletado(true)
            } else {
                elToast( d.mensaje, 'error' )
            }
        })
        .catch( a => {
            elToast("Error al guardar archivo.\nPuedes revisar tu conexión o iniciar sesión nuevamente.", "error")
        })
        .finally( () => setCargando( false ) )
    }

    const cambiarInput = () => {
        setMostrarInput( !mostrarInput )
    }


    // useEffect

    useEffect(() => {
        traerNombreArchivo(tipo)
        // eslint-disable-next-line
    }, [])



    return {
        procesarArchivo, cargando, cambiarInput, mostrarInput, mostrarOcultar, setmostrarOcultar,
        setMostrarInput, nombreArchivo, completado
    }
}

export default useInputArchivo
